import React from "react";
import type { IFormItemLayout, TSourceOfWealth } from "@adgm/cross-models";
import MultiCheckboxSubForm from "./MultiCheckboxSubForm";
import { INDIVIDUAL_SOURCE_OF_WEALTH_CONFIG } from "./IndividualSourceOfWealthFormConfig";

interface IProps extends IFormItemLayout<TSourceOfWealth | null> {
  value?: TSourceOfWealth | null;
  onChange: (value: TSourceOfWealth) => void;
  style?: any;
}

/**
 * 个人财富来源表单组件
 * 用于输入个人财富来源信息
 */
export const IndividualSourceOfWealthForm: React.FC<IProps> = props => {
  return (
    <MultiCheckboxSubForm<TSourceOfWealth> {...props} config={INDIVIDUAL_SOURCE_OF_WEALTH_CONFIG} />
  );
};
